<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>
        <div class="wrap-title">
          <label class="label-input">Content</label>
          <div class="mb-5">
            <label class="">Title Content</label>
            <ckeditor :editor="editor" v-model="fields.titleContent" :config="editorConfig" />
          </div>
          <div class="mb-5">
            <div class="">Table Kubo</div>
            <ckeditor :editor="editor" v-model="fields.tableKubo" :config="editorConfig" />
          </div>
          <div class="mb-5">
            <div class="d-flex align-center gap-3">
              <input
                type="color"
                name="background-color"
                style="width: 40px; height: 40px; margin-right: 12px"
                :value="fields.backgroundColor"
                @change="handleChangeBackgroundColor"
              />
              <v-text-field v-model="fields.backgroundColor" label="Background Color" />
              <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
            </div>
          </div>
          <div class="mb-5 d-flex align-center gap-3">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.borderSpacingVertical"
                  label="Border Spacing Vertical (px)"
                  type="number"
                  :rules="[v => !v || v >= 0 || 'Border spacing must be greater than or equal to 0']"
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="fields.borderSpacingHorizontal"
                  label="Border Spacing Horizontal (px)"
                  type="number"
                  :rules="[v => !v || v >= 0 || 'Border spacing must be greater than or equal to 0']"
                />
              </v-col>
            </v-row>
          </div>
          <v-row>
            <v-col cols="12">
              <div>
                <div>
                  <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
                    <label for="backgroundImageEnable" style="margin-bottom: 0" class="font-weight-bold"
                      >Background Image</label
                    >
                    <input type="checkbox" v-model="fields.backgroundImage.enable" id="backgroundImageEnable" />
                  </div>
                </div>
                <UploadImage
                  @callback="handleUploadBackgroundImage"
                  :image="{ imageSrc: fields.backgroundImage.image }"
                  :height="`250`"
                  :typeUpload="'image'"
                  @callbackDelete="handleRemoveBackgroundImage"
                />
              </div>
            </v-col>
          </v-row>
        </div>
        <div class="mt-6">
          <label class="label-input mb-0">Padding </label>
          <v-row>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
              </div>
            </v-col>
            <v-col md="6" cols="12">
              <div class="d-flex align-center">
                <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
export default {
  name: 'table-kubo-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        backgroundColor: '',
        backgroundImage: {
          enable: false,
          image: '',
        },
        titleContent: '',
        tableKubo: '',
        topPadding: true,
        bottomPadding: true,
        borderSpacingVertical: 0,
        borderSpacingHorizontal: 10,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionTableKubo(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },

    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields.backgroundColor = '#ffffff';
    },
    handleChangeHeaderColor(event) {
      this.fields.tableHeaderColor = event.target.value;
    },
    handleResetHeaderColor() {
      this.fields.tableHeaderColor = '#6598fa';
    },
    handleChangeOddRowColor(event) {
      this.fields.tableOddRowColor = event.target.value;
    },
    handleResetOddRowColor() {
      this.fields.tableOddRowColor = '#f2f2f2';
    },
    handleUploadBackgroundImage(obj) {
      this.fields.backgroundImage.image = obj.imageSrc;
      this.fields.backgroundImage.enable = true;
    },
    handleRemoveBackgroundImage() {
      this.fields.backgroundImage.image = '';
      this.fields.backgroundImage.enable = false;
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .wrap-title {
  .ck-editor__editable {
    min-height: 150px !important;
  }
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
